import './SelectField.scss';

import clsx from 'clsx';
import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import Select from '@/src/components/common/Select/Select';
import { cn } from '@/src/util/ui';

import { DROPDOWN_EMPTY_MESSAGE } from '../../../../Config';
import ErrorDisplay from '../ErrorDisplay/ErrorDisplay';

type SelectFieldClasses = {
  container?: string;
  main?: string;
  options?: string;
};

export type Option = {
  value: any;
  label: string;
  type?: string;
};

export const renderWithTypeOptions = (option: Option) => {
  return (
    <div className={clsx('optionItemContainer', 'tw-w-full')}>
      <span>{option.label}</span>
      <span className="text-italic text-right">{option.type}</span>
    </div>
  );
};

const SelectField = ({
  isSearchable = false,
  isAiGenerated = false,
  tooltip = null,
  classes = {} as SelectFieldClasses,
  firstOption = null,
  renderSelected = null,
  errorSettings = { hasError: false, content: 'Error' },
  showActiveIcon = true,
  isManualExpensePrefilled = false,
  ...otherProps
}) => {
  const customClasses = {
    main: cn(
      'commonSelectOption',
      !!classes.main && classes.main,
      errorSettings.hasError && '!tw-border-cfo-red-400'
    ),
    options: classes.options,
    trigger: isAiGenerated && '!tw-bg-[rgba(240,232,250,1)]',
  };

  const selectIconClass = clsx('material-icons', otherProps.disabled && '!tw-text-cfo-grey-400');

  if (tooltip) {
    return (
      <React.Fragment>
        <div className={clsx('selectInner--wrapper', classes.container)}>
          <Select
            placeholder={'Select'}
            classes={customClasses}
            searchIcon={<i className={selectIconClass}>expand_more</i>}
            clearIcon={<i className="material-icons">cancel</i>}
            isFirstItemSelected={false}
            isSearchable={isSearchable}
            emptyMessage={DROPDOWN_EMPTY_MESSAGE}
            tooltipID={tooltip.id}
            isAiGenerated={isAiGenerated}
            isManualExpensePrefilled={isManualExpensePrefilled}
            firstOption={firstOption}
            renderSelected={renderSelected}
            {...otherProps}
          />
          {/* Displays if errorSettings hasError is true */}
          {errorSettings.hasError && <ErrorDisplay errorMessage={errorSettings.content} />}
        </div>

        {tooltip && (
          <Tooltip
            className={tooltip.className}
            id={`${tooltip.id}`}
            place={'bottom'}
            effect={'solid'}
          >
            {tooltip.content}
          </Tooltip>
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className={clsx('selectInner--wrapper', classes.container)}>
        <Select
          placeholder={'Select'}
          classes={customClasses}
          searchIcon={<i className={selectIconClass}>expand_more</i>}
          isFirstItemSelected={false}
          isSearchable={isSearchable}
          emptyMessage={DROPDOWN_EMPTY_MESSAGE}
          showActiveIcon={showActiveIcon}
          isAiGenerated={isAiGenerated}
          firstOption={firstOption}
          renderSelected={renderSelected}
          isManualExpensePrefilled={isManualExpensePrefilled}
          {...otherProps}
        />
        {errorSettings.hasError && <ErrorDisplay errorMessage={errorSettings.content} />}
      </div>
    </React.Fragment>
  );
};

export default SelectField;
